module.exports = __webpack_public_path__ + "static/media/starPartialOff_326.b54f44d2.png";